<div class="fal-lite-filter-section">
  <fal-lite-filters
    class="filter-dialog-height"
    [filtersModel]="filtersModel"
    [defaultSearchDistance]="defaultSearchDistance"
    [showSearchRadiusFilter]="showSearchRadiusFilter"
    [searchRadiusFilterDisplayText]="searchRadiusFilterDisplayText"
    [showServicesAvailableFilter]="showServicesAvailableFilter"
    [servicesAvailableFilterDisplayText]="servicesAvailableFilterDisplayText"
    [showLocationTypeFilter]="showLocationTypeFilter"
    [locationTypeFilterDisplayText]="locationTypeFilterDisplayText"
    [isLocationSelected]="isLocationSelected"
    (filtersModelChange)="handleFilterChange($event)"
    [showLandingFilters]="showLandingFilters"
  ></fal-lite-filters>
</div>
